module.exports = __webpack_public_path__ + "img/14-sdg-border@2x.d7cb3878.png";